import React, { useEffect, createElement } from 'react';
const HOP_LINK = 'https://2a2c3etilm79k5v8phfdpkp51j.hop.clickbank.net';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
const handleCtaClick = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout');
  }
};
export function App() {
  useEffect(() => {
    // Inject Facebook Pixel Base Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '666521186552257');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Noscript fallback pixel image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=666521186552257&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      if (script.parentNode) document.head.removeChild(script);
      if (noscript.parentNode) document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white font-sans" data-id="element-0">
      {/* TOP URGENCY BAR */}
      <div className="bg-red-600 text-white text-center py-2 px-4 text-sm font-bold animate-pulse" data-id="element-1">
        ⚠️ HIGH DEMAND ALERT — Only A Few Spots Left At This Special Price
        Today!
      </div>

      <div className="max-w-2xl mx-auto px-4 py-8 text-center" data-id="element-2">
        {/* EYEBROW */}
        <p className="text-blue-600 font-bold text-sm uppercase tracking-widest mb-2" data-id="element-3">
          🍵 Viral Morning Ritual · Women 40+ Are Talking About This
        </p>

        {/* MAIN HEADLINE */}
        <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 leading-tight mb-3" data-id="element-4">
          Doctors Are Surprised By This{' '}
          <span className="text-blue-700 underline decoration-wavy" data-id="element-5">
            100% Natural Tea
          </span>{' '}
          That Supports Heart Health <span className="text-red-600" data-id="element-6">AND</span>{' '}
          Melts Stubborn Fat
        </h1>

        <p className="text-lg text-gray-600 mb-6" data-id="element-7">
          Thousands of women over 40 are starting their morning with{' '}
          <strong data-id="element-8">Cardio Slim Tea</strong> — and the results are turning heads.
        </p>

        {/* PRODUCT IMAGE */}
        <div className="mb-6 flex justify-center" data-id="element-9">
          <img src="https://cdn.magicpatterns.com/uploads/pgLynctgGcb5mRSEoGuKNu/new_1-01_copy.png" alt="Cardio Slim Tea - 100% Natural Herbal Tea" className="w-full max-w-xs object-contain drop-shadow-2xl" data-id="element-10" />
        </div>

        {/* SOCIAL PROOF BAR */}
        <div className="bg-white border border-blue-100 rounded-2xl p-4 mb-6 shadow-md" data-id="element-11">
          <div className="flex justify-around text-center" data-id="element-12">
            <div data-id="element-13">
              <p className="text-3xl font-extrabold text-blue-700" data-id="element-14">143K+</p>
              <p className="text-xs text-gray-500" data-id="element-15">Happy Customers</p>
            </div>
            <div className="border-l border-blue-100" data-id="element-16" />
            <div data-id="element-17">
              <p className="text-3xl font-extrabold text-blue-700" data-id="element-18">⭐ 4.9</p>
              <p className="text-xs text-gray-500" data-id="element-19">Average Rating</p>
            </div>
            <div className="border-l border-blue-100" data-id="element-20" />
            <div data-id="element-21">
              <p className="text-3xl font-extrabold text-blue-700" data-id="element-22">30</p>
              <p className="text-xs text-gray-500" data-id="element-23">Tea Bags / Pack</p>
            </div>
          </div>
        </div>

        {/* BRIDGE STORY */}
        <div className="text-left bg-blue-50 rounded-2xl p-6 shadow-md mb-6 border-l-4 border-blue-500" data-id="element-24">
          <p className="text-gray-800 text-base leading-relaxed mb-3" data-id="element-25">
            <strong data-id="element-26">Linda, 52, from Houston</strong> had tried every weight loss
            program imaginable. But after 40, her metabolism had slowed down —
            and her doctor warned her about her blood pressure too.
          </p>
          <p className="text-gray-800 text-base leading-relaxed mb-3" data-id="element-27">
            A friend recommended she try{' '}
            <strong className="text-blue-700" data-id="element-28">Cardio Slim Tea</strong> — a 100%
            natural herbal formula designed to support{' '}
            <strong data-id="element-29">heart health AND natural weight loss</strong> at the same
            time.
          </p>
          <p className="text-gray-800 text-base leading-relaxed" data-id="element-30">
            In just <strong data-id="element-31">3 weeks</strong>, Linda lost 9 lbs, her energy
            skyrocketed, and her next checkup showed{' '}
            <strong data-id="element-32">improved blood pressure levels.</strong> Her doctor was
            amazed.
          </p>
        </div>

        {/* WHAT'S INSIDE */}
        <div className="bg-white border border-blue-200 rounded-2xl p-5 mb-6 text-left shadow-sm" data-id="element-33">
          <h3 className="text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-34">
            🍵 What Makes Cardio Slim Tea Different?
          </h3>
          <ul className="space-y-3" data-id="element-35">
            {['✅ Supports Healthy Blood Pressure Levels*', '✅ Helps In Natural Weight Loss*', '✅ Improves Energy Levels & Metabolism*', '✅ Advanced Cardiovascular Health Formula*', '✅ Helps Alleviate Stress & Supports Wellness*', '✅ 100% Natural · Organic · Non-GMO · Gluten-Free · Soy-Free', '✅ Independently Tested · 30 Tea Bags Per Pack'].map((item, i) => <li key={i} className="text-gray-800 font-medium text-sm" data-id="element-36">
                {item}
              </li>)}
          </ul>
        </div>

        {/* HOW IT WORKS */}
        <div className="bg-gradient-to-r from-blue-700 to-blue-500 text-white rounded-2xl p-6 mb-6 text-left shadow-xl" data-id="element-37">
          <h3 className="text-xl font-bold mb-4 text-center" data-id="element-38">
            ☀️ Your New 3-Step Morning Ritual
          </h3>
          <div className="space-y-3" data-id="element-39">
            {[{
            step: '1',
            text: 'Wake up and boil fresh water'
          }, {
            step: '2',
            text: 'Steep one Cardio Slim Tea bag for 5 minutes'
          }, {
            step: '3',
            text: 'Drink it warm and feel the difference within days'
          }].map(s => <div key={s.step} className="flex items-center gap-3" data-id="element-40">
                <div className="bg-white text-blue-700 font-extrabold rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0" data-id="element-41">
                  {s.step}
                </div>
                <p className="text-sm font-medium" data-id="element-42">{s.text}</p>
              </div>)}
          </div>
        </div>

        {/* TESTIMONIALS */}
        <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-43">
          Real Women. Real Results.
        </h3>
        <div className="space-y-4 mb-8" data-id="element-44">
          {[{
          name: 'Jennifer M., 54 — Florida',
          text: 'I started drinking Cardio Slim Tea every morning and lost 12 lbs in 5 weeks. My heart feels stronger and I have more energy than I did at 35!',
          stars: '⭐⭐⭐⭐⭐'
        }, {
          name: 'Maria R., 47 — California',
          text: 'My doctor actually asked me what I was doing differently. My blood pressure improved and I dropped 2 dress sizes. This tea is a miracle!',
          stars: '⭐⭐⭐⭐⭐'
        }, {
          name: 'Deborah K., 50 — New York',
          text: "I was skeptical about another supplement. But Cardio Slim Tea is different — it's a real tea that actually works. I've lost 8 lbs and feel amazing.",
          stars: '⭐⭐⭐⭐⭐'
        }].map((t, i) => <div key={i} className="bg-white border border-gray-200 rounded-2xl p-4 text-left shadow-sm" data-id="element-45">
              <p className="text-yellow-500 text-lg mb-1" data-id="element-46">{t.stars}</p>
              <p className="text-gray-700 text-sm italic mb-2" data-id="element-47">"{t.text}"</p>
              <p className="text-gray-500 text-xs font-semibold" data-id="element-48">— {t.name}</p>
            </div>)}
        </div>

        {/* GUARANTEE BADGE */}
        <div className="bg-green-50 border border-green-300 rounded-2xl p-5 mb-6 flex items-center gap-4" data-id="element-49">
          <div className="text-5xl" data-id="element-50">🛡️</div>
          <div className="text-left" data-id="element-51">
            <p className="font-extrabold text-green-800 text-lg" data-id="element-52">
              60-Day Money Back Guarantee
            </p>
            <p className="text-green-700 text-sm" data-id="element-53">
              Try Cardio Slim Tea completely risk-free. If you're not 100%
              satisfied, get a full refund — no questions asked.
            </p>
          </div>
        </div>

        {/* MAIN CTA */}
        <div className="mb-4" data-id="element-54">
          <a href={HOP_LINK} target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="block w-full bg-green-500 hover:bg-green-600 text-white text-2xl font-extrabold py-5 px-8 rounded-2xl shadow-xl transition-all duration-200 transform hover:scale-105 text-center" data-id="element-55">
            👉 YES! I Want Cardio Slim Tea Now →
          </a>
          <p className="text-xs text-gray-400 mt-2 text-center" data-id="element-56">
            🔒 Secure Order · 60-Day Guarantee · 100% Natural Formula
          </p>
        </div>

        {/* SECONDARY CTA */}
        <a href={HOP_LINK} target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="block w-full bg-blue-700 hover:bg-blue-800 text-white text-lg font-bold py-4 px-6 rounded-xl shadow-lg transition-all duration-200 text-center mb-8" data-id="element-57">
          ⚡ Claim Your Special Discount — Limited Time Only
        </a>

        {/* URGENCY */}
        <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6" data-id="element-58">
          <p className="text-red-700 font-bold text-sm text-center" data-id="element-59">
            ⏰ Due to high demand, stock is extremely limited. Secure your order
            now before this offer expires.
          </p>
        </div>

        {/* CERTIFICATIONS */}
        <div className="flex justify-center gap-6 mb-6 flex-wrap" data-id="element-60">
          {['🌿 Organic', '🚫 Non-GMO', '✅ Gluten-Free', '🔬 Lab Tested', '🫘 Soy-Free'].map((badge, i) => <div key={i} className="bg-blue-100 text-blue-800 text-xs font-bold px-3 py-2 rounded-full" data-id="element-61">
              {badge}
            </div>)}
        </div>

        {/* DISCLAIMER */}
        <p className="text-xs text-gray-400 text-center leading-relaxed pb-20" data-id="element-62">
          * These statements have not been evaluated by the Food and Drug
          Administration. This product is not intended to diagnose, treat, cure,
          or prevent any disease. Results may vary. Individual testimonials are
          not guaranteed. Please consult your healthcare provider before
          starting any supplement program.
        </p>
      </div>

      {/* STICKY BOTTOM CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-green-500 p-3 shadow-2xl z-50 border-t-4 border-green-700" data-id="element-63">
        <a href={HOP_LINK} target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="block text-center text-white font-extrabold text-lg" data-id="element-64">
          🍵 Get Cardio Slim Tea — Special Price Today →
        </a>
      </div>
    </div>;
}